import {
    Box,
    Button,
    Checkbox,
    Flex,
    FormControl,
    FormHelperText,
    FormLabel,
    Input,
    Select,
    Stack,
    Table,
    TableContainer,
    Tbody,
    Td,
    Text,
    Textarea,
    Th,
    Thead,
    Tr,
} from '@chakra-ui/react';
import { AddIcon, DeleteIcon } from '@chakra-ui/icons';
import usePipelineStore from '../../../../stores/pipeline-store';
import { VarSelect } from '../inputs';

type SendMessageStepSettingsProps = {
    stepId: string;
};
export function SendMessageStepSettings({ stepId }: SendMessageStepSettingsProps) {
    const { pipeline, updateStep } = usePipelineStore((state) => state);
    const step = pipeline.steps[stepId] as SendMessageStep;

    return (
        <Box mx={-3}>
            <FormControl>
                <FormLabel>Platform</FormLabel>
                <Select
                    color={step.platform == '' ? 'grey' : 'black'}
                    value={step.platform}
                    backgroundColor="white"
                    onChange={({ target: { value } }: any) => {
                        updateStep(stepId, 'platform', value);
                    }}
                >
                    <option value="" disabled={true}>
                        Select Platform
                    </option>
                    <option value="sms">SMS</option>
                    <option value="whatsapp">Whatsapp</option>
                    <option value="email">Email</option>
                    <option disabled={true} value="telegram">
                        Telegram (coming soon..)
                    </option>
                    <option disabled={true} value="slack">
                        Slack (coming soon..)
                    </option>
                </Select>
            </FormControl>
            {step.platform === 'email' ? (
                <FormControl mt={2}>
                    <FormLabel>Email address</FormLabel>
                    <VarSelect
                        value={step.emailVarId}
                        filterByType={['STRING']}
                        onChange={(value) => updateStep(stepId, 'emailVarId', value)}
                    />
                </FormControl>
            ) : (
                <FormControl mt={2}>
                    <FormLabel>Phone Number</FormLabel>
                    <VarSelect
                        value={step.phoneNumberVarId}
                        filterByType={['STRING']}
                        onChange={(value) => updateStep(stepId, 'phoneNumberVarId', value)}
                    />
                </FormControl>
            )}

            {step.platform == 'sms' && (
                <>
                    <FormControl mt={2}>
                        <FormLabel>Sender Name Var</FormLabel>
                        <VarSelect
                            value={step.senderNameVarId || ''}
                            placeholder="milgo (default)"
                            filterByType={['STRING']}
                            onChange={(value) => updateStep(stepId, 'senderNameVarId', value)}
                        />
                    </FormControl>

                    <FormControl mt={2}>
                        <FormLabel>Message</FormLabel>
                        <Textarea
                            dir={/[\u0590-\u05FF]/.test(step.message) ? 'rtl' : 'ltr'}
                            resize={'none'}
                            placeholder=""
                            id="step-description"
                            autoComplete="off"
                            aria-describedby="password-helper-text"
                            value={step.message}
                            onChange={({ target: { value } }: any) => {
                                updateStep(stepId, 'message', value);
                            }}
                        />
                        <FormHelperText>{'Use ${varName} to embed a var'}</FormHelperText>
                    </FormControl>
                </>
            )}

            {step.platform == 'whatsapp' && (
                <>
                    <FormControl mt={2}>
                        <FormLabel>Template Id</FormLabel>
                        <Flex>
                            <Checkbox
                                isChecked={step.isTemplateIdFromVar}
                                onChange={({ target: { checked } }: any) => {
                                    updateStep(stepId, 'isTemplateIdFromVar', checked);
                                }}
                            >
                                <Text minW={16} fontSize={'xs'}>
                                    From var?{' '}
                                </Text>
                            </Checkbox>
                            {step.isTemplateIdFromVar ? (
                                <VarSelect
                                    value={step.messageTemplateIdFromVar}
                                    placeholder="Source"
                                    filterByType={['STRING']}
                                    onChange={(value) => updateStep(stepId, 'messageTemplateIdFromVar', value)}
                                />
                            ) : (
                                <Input
                                    backgroundColor="white"
                                    placeholder="Whatsapp template id"
                                    value={
                                        step.messageTemplateId ? step.messageTemplateId : step.messageTemplateIdConst
                                    } //backwords compatability
                                    onChange={({ target: { value } }: any) => {
                                        updateStep(stepId, 'messageTemplateId', value);
                                    }}
                                />
                            )}
                        </Flex>
                    </FormControl>
                    <FormControl mt={2}>
                        <FormLabel>Template vars</FormLabel>
                        <TableContainer>
                            <Table variant={'unstyled'}>
                                <Thead>
                                    <Tr>
                                        <Th>Template var</Th>
                                        <Th>Pipeline var</Th>
                                    </Tr>
                                </Thead>
                                <Tbody>
                                    {step.messageTemplateOptions.map((option, index) => {
                                        return (
                                            <Tr key={index}>
                                                <Td paddingTop={'0 !important'} paddingEnd={'0 !important'}>
                                                    <Input
                                                        backgroundColor="white"
                                                        w="100%"
                                                        placeholder="templateVar"
                                                        value={
                                                            option.templateVarId
                                                                ? option.templateVarId
                                                                : `[#${index + 1}#]`
                                                        }
                                                        onChange={({ target: { value } }: any) => {
                                                            let messageTemplateOptions = JSON.parse(
                                                                JSON.stringify(step.messageTemplateOptions),
                                                            );
                                                            messageTemplateOptions[index].templateVarId = value;
                                                            updateStep(
                                                                stepId,
                                                                'messageTemplateOptions',
                                                                messageTemplateOptions,
                                                            );
                                                        }}
                                                    />
                                                </Td>
                                                <Td paddingTop={'0 !important'} paddingEnd={'0 !important'}>
                                                    <VarSelect
                                                        value={option.sourceVarId}
                                                        placeholder="Select Var"
                                                        filterByType={['STRING', 'NUMBER']}
                                                        onChange={(value) => {
                                                            let messageTemplateOptions = JSON.parse(
                                                                JSON.stringify(step.messageTemplateOptions),
                                                            );
                                                            messageTemplateOptions[index].sourceVarId = value;
                                                            updateStep(
                                                                stepId,
                                                                'messageTemplateOptions',
                                                                messageTemplateOptions,
                                                            );
                                                        }}
                                                    />
                                                </Td>
                                                <Td paddingTop={'0 !important'} paddingInline={'0 !important'}>
                                                    <Button
                                                        backgroundColor="white"
                                                        _hover={{ color: '#f0706e' }}
                                                        _focus={{
                                                            backgroundColor: 'white',
                                                        }}
                                                        _active={{
                                                            backgroundColor: 'white',
                                                        }}
                                                        color={'grey'}
                                                        leftIcon={<DeleteIcon />}
                                                        onClick={() => {
                                                            let messageTemplateOptions = JSON.parse(
                                                                JSON.stringify(step.messageTemplateOptions),
                                                            );
                                                            messageTemplateOptions.splice(index, 1);
                                                            updateStep(
                                                                stepId,
                                                                'messageTemplateOptions',
                                                                messageTemplateOptions,
                                                            );
                                                        }}
                                                    />
                                                </Td>
                                            </Tr>
                                        );
                                    })}
                                </Tbody>
                            </Table>
                        </TableContainer>
                        <Stack>
                            <Button
                                size={'sm'}
                                backgroundColor="white"
                                _hover={{
                                    backgroundColor: 'white',
                                    color: 'black',
                                }}
                                _focus={{ backgroundColor: 'white' }}
                                _active={{ backgroundColor: 'white' }}
                                color={'grey'}
                                leftIcon={<AddIcon />}
                                onClick={() => {
                                    let messageTemplateOptions = JSON.parse(
                                        JSON.stringify(step.messageTemplateOptions),
                                    );
                                    messageTemplateOptions.push({
                                        sourceVarId: '',
                                        templateVarId: `[#${messageTemplateOptions.length + 1}#]`,
                                    });
                                    updateStep(stepId, 'messageTemplateOptions', messageTemplateOptions);
                                }}
                            >
                                Add Element
                            </Button>
                        </Stack>
                    </FormControl>
                </>
            )}

            {step.platform == 'email' && (
                <>
                    <FormControl mt={2}>
                        <FormLabel>Email Template</FormLabel>
                        <Flex>
                            <Checkbox
                                isChecked={step.isTemplateIdFromVar}
                                onChange={({ target: { checked } }: any) => {
                                    updateStep(stepId, 'isTemplateIdFromVar', checked);
                                }}
                            >
                                <Text minW={16} fontSize={'xs'}>
                                    From var?{' '}
                                </Text>
                            </Checkbox>
                            {step.isTemplateIdFromVar ? (
                                <VarSelect
                                    value={step.messageTemplateIdFromVar}
                                    placeholder="Source"
                                    filterByType={['STRING']}
                                    onChange={(value) => updateStep(stepId, 'messageTemplateIdFromVar', value)}
                                />
                            ) : (
                                <Input
                                    backgroundColor="white"
                                    placeholder="Email template id"
                                    value={
                                        step.messageTemplateId ? step.messageTemplateId : step.messageTemplateIdConst
                                    } //backwords compatability
                                    onChange={({ target: { value } }: any) => {
                                        updateStep(stepId, 'messageTemplateId', value);
                                    }}
                                />
                            )}
                        </Flex>
                    </FormControl>

                    <FormControl mt={2}>
                        <FormLabel>Template vars</FormLabel>
                        <TableContainer>
                            <Table variant={'unstyled'}>
                                <Thead>
                                    <Tr>
                                        <Th>Template var</Th>
                                        <Th>Pipeline var</Th>
                                    </Tr>
                                </Thead>
                                <Tbody>
                                    {step.messageTemplateOptions.map((option, index) => {
                                        return (
                                            <Tr key={index}>
                                                <Td paddingTop={'0 !important'} paddingEnd={'0 !important'}>
                                                    <Input
                                                        backgroundColor="white"
                                                        w="100%"
                                                        placeholder="templateVar"
                                                        value={
                                                            option.templateVarId
                                                                ? option.templateVarId
                                                                : `[#${index + 1}#]`
                                                        }
                                                        onChange={({ target: { value } }: any) => {
                                                            let messageTemplateOptions = JSON.parse(
                                                                JSON.stringify(step.messageTemplateOptions),
                                                            );
                                                            messageTemplateOptions[index].templateVarId = value;
                                                            updateStep(
                                                                stepId,
                                                                'messageTemplateOptions',
                                                                messageTemplateOptions,
                                                            );
                                                        }}
                                                    />
                                                </Td>
                                                <Td paddingTop={'0 !important'} paddingEnd={'0 !important'}>
                                                    <VarSelect
                                                        value={option.sourceVarId}
                                                        placeholder="Select Var"
                                                        filterByType={['STRING', 'NUMBER']}
                                                        onChange={(value) => {
                                                            let messageTemplateOptions = JSON.parse(
                                                                JSON.stringify(step.messageTemplateOptions),
                                                            );
                                                            messageTemplateOptions[index].sourceVarId = value;
                                                            updateStep(
                                                                stepId,
                                                                'messageTemplateOptions',
                                                                messageTemplateOptions,
                                                            );
                                                        }}
                                                    />
                                                </Td>
                                                <Td paddingTop={'0 !important'} paddingInline={'0 !important'}>
                                                    <Button
                                                        backgroundColor="white"
                                                        _hover={{ color: '#f0706e' }}
                                                        _focus={{
                                                            backgroundColor: 'white',
                                                        }}
                                                        _active={{
                                                            backgroundColor: 'white',
                                                        }}
                                                        color={'grey'}
                                                        leftIcon={<DeleteIcon />}
                                                        onClick={() => {
                                                            let messageTemplateOptions = JSON.parse(
                                                                JSON.stringify(step.messageTemplateOptions),
                                                            );
                                                            messageTemplateOptions.splice(index, 1);
                                                            updateStep(
                                                                stepId,
                                                                'messageTemplateOptions',
                                                                messageTemplateOptions,
                                                            );
                                                        }}
                                                    />
                                                </Td>
                                            </Tr>
                                        );
                                    })}
                                </Tbody>
                            </Table>
                        </TableContainer>
                        <Stack>
                            <Button
                                size={'sm'}
                                backgroundColor="white"
                                _hover={{
                                    backgroundColor: 'white',
                                    color: 'black',
                                }}
                                _focus={{ backgroundColor: 'white' }}
                                _active={{ backgroundColor: 'white' }}
                                color={'grey'}
                                leftIcon={<AddIcon />}
                                onClick={() => {
                                    let messageTemplateOptions = JSON.parse(
                                        JSON.stringify(step.messageTemplateOptions),
                                    );
                                    messageTemplateOptions.push({
                                        sourceVarId: '',
                                        templateVarId: `[#${messageTemplateOptions.length + 1}#]`,
                                    });
                                    updateStep(stepId, 'messageTemplateOptions', messageTemplateOptions);
                                }}
                            >
                                Add Element
                            </Button>
                        </Stack>
                    </FormControl>
                </>
            )}
        </Box>
    );
}
